import React from 'react';
import styled from 'styled-components';
import CheckedIcon from '../../assets/icons/check_box_24px.svg?react';
import UncheckedIcon from '../../assets/icons/check_box_off_24px.svg?react';

interface CustomCheckboxProps {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  children?: React.ReactNode;
}

const CheckboxContainer = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  gap: 8px;
`;

const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
`;

const IconWrapper = styled.div<{ checked: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  
  svg {
    width: 24px;
    height: 24px;
    
    path {
      fill: ${props => props.checked ? '#2563EB' : '#E5E7EB'};
    }
  }
`;

const Label = styled.span`
  font-family: Inter;
  font-weight: 400;
  font-size: 14px;
  color: #1F2937;
  line-height: 20px;
`;

const CustomCheckbox: React.FC<CustomCheckboxProps> = ({ checked = false, onChange, children }) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(e.target.checked);
  };

  return (
    <CheckboxContainer>
      <HiddenCheckbox checked={checked} onChange={handleChange} />
      <IconWrapper checked={checked}>
        {checked ? <CheckedIcon /> : <UncheckedIcon />}
      </IconWrapper>
      {children && <Label>{children}</Label>}
    </CheckboxContainer>
  );
};

export default CustomCheckbox;

